import { createAppSlice } from '../app.slice';

const initialState = {
  data: [],
  selectedAccount: null,
};

export const accountBalanceSlice = createAppSlice({
  name: 'accountBalanceSlice',
  initialState,
  reducers: {
    accountBalanceRequest: (state) => state,
    accountBalanceSuccess: (state, action) => {
      state.data = action.payload;
    },
    accountBalanceFailure: (state) => {
      state.data = [];
      state.selectedAccount = null;
    },
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
  },
});
